import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" data-id="element-137" data-mp="122vf0mmg35sn">
      <div className="mx-auto max-w-3xl" data-id="element-138" data-mp="1prxupoxiqoki">
        <SectionHeading title="Frequently Asked Questions" data-id="element-139" data-mp="1pszechslojdu" />
        <div className="mt-10 space-y-3" data-id="element-140" data-mp="1uq92zv860r0m">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="rounded-2xl bg-white ring-1 ring-ink/10" data-id="element-141" data-mp="1g0bmm1gh95lz" data-mpi={i}>
                <h3 data-id="element-142" data-mp="1kzwmqf7dvk0a">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[16px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-forest rounded-2xl" data-id="element-143" data-mp="1kzejgymb05iv">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-forest transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-144" data-mp="2ygtr8btw9jv5" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-145" data-mp="32iey9gjqz3xf">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-146" data-mp="3hemmcrya0phz">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-147" data-mp="27q7fx0ujc11q">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <div className="mt-10" data-id="element-148" data-mp="2gpuihpz03cwd">
          <CtaButton label="My questions are answered — I'm in" data-id="element-149" data-mp="2gsys52v8j0uf" />
        </div>
      </div>
    </section>;
}